(function () {
  let clickedButton = document.getElementById("addButton");
  let formCount;
  if (clickedButton) {
    formCount = clickedButton.dataset.stepsLength;

    document
      .getElementById("addButton")
      .addEventListener("click", function (event) {
        let originalForm = document.querySelector(".js-steps");
        const stepFormId = document.getElementById(
          "id_toolkit_steps-TOTAL_FORMS"
        );
        const stepItems = originalForm.querySelectorAll(".simple-card");
        let clonedSection;
        const stepsCount = stepItems.length;
        if (stepsCount === 0) {
          // Create the desired HTML structure
          clonedSection = document.createElement("div");
          clonedSection.className = "simple-card mg-b-s simple-card--editable";

          clonedSection.innerHTML = `
            <div class="status-bar" aria-hidden="true" hidden="" role="status" aria-atomic="true">Step added<span class="arrow"></span>
            </div>
            <button type="button" class="btn-edit toggle-content" aria-expanded="false" aria-controls="step-form-5" aria-label="Edit step 5" hidden="">Edit <span>step</span></button>
            <div>
                <div class="simple-card__heading bold"><span class="step-counter">Step 5: </span><span class="text-reg">Add new step</span></div>
                <div class="full-content full-content--border-top mg-t-s" aria-hidden="false" id="step-form-5"><div class="fieldWrapper form-control">
              <div class="fieldInputWrapper">
                <label class="label" for="id_toolkit_steps-0-name">Step title</label>
                <p class="field-desc">Create and edit steps below</p>
                <input type="text" required="true" id="id_toolkit_steps-0-name" name="toolkit_steps-0-name" class="form-control">
                <div class="fieldErrorWrapper "></div>
              </div>
          <div class="fieldWrapper  form-control  fieldWrapper_delivery_description">
              <div class="fieldInputWrapper  ">
                <label for="id_toolkit_steps-0-delivery_description" class="no-mg-b"> How will you deliver this step?</label>
                <p class="field-desc"><strong>Example:</strong> Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce lorem velit ipsum fermentum eget eu malesuada. Id ultricies quis aenean fermentum faucibu.</p>
                <textarea name="toolkit_steps-0-delivery_description" cols="00" rows="10" class="form-control" placeholder="Enter a description here" required="true" id="id_toolkit_steps-0-delivery_description">step 1</textarea>
              </div>
              <div class="fieldErrorWrapper"></div>
          </div>
          <fieldset class="small-label">
              <legend class="label">Timeline</legend>
              <div class="form-fields-half form-fields-half--spacer">
            <div class="fieldWrapper  form-control  fieldWrapper_start_date">
                <div class="fieldInputWrapper  ">
                <label for="id_toolkit_steps-0-start_date" class=""> Start date</label>
              <input type="date" name="toolkit_steps-0-start_date" value="" class="form-control" placeholder="Start date" required="true" min="" id="id_toolkit_steps-0-start_date">
                </div>
                <div class="fieldErrorWrapper"></div>
            </div>
            <div class="fieldWrapper  form-control  fieldWrapper_end_date">
                <div class="fieldInputWrapper  ">
                  <label for="id_toolkit_steps-0-end_date" class=""> End date</label>
                  <input type="date" name="toolkit_steps-0-end_date" value="" class="form-control" placeholder="End date" required="true" min="" id="id_toolkit_steps-0-end_date">
                </div>
                <div class="fieldErrorWrapper"></div>
            </div>
          </div>
        </fieldset>
        <fieldset class="small-label">
            <legend class="label no-mg-b">Who is responsible?</legend>
            <p class="field-desc">Nominate an owner of this step.</p>
          <div class="form-fields-half">
            <div class="fieldWrapper  form-control  fieldWrapper_owner_name">
              <div class="fieldInputWrapper  ">
                <label for="id_toolkit_steps-0-owner_name" class=""> Name</label>
                <input type="text" name="toolkit_steps-0-owner_name" value="Somy" class="form-control" placeholder="Name" required="true" id="id_toolkit_steps-0-owner_name">
              </div>
            <div class="fieldErrorWrapper"></div>
          </div>
          </div>
        </fieldset>
        <div class="cta-container">
          <button type="button" class="btn-tertiary js-delete-step">delete</button><button type="button" class="btn btn-primary js-validate-fields">Save</button>
        </div>
      </div>
    </div>`;
        } else {
          // Clone the last step item
          clonedSection = stepItems[stepsCount - 1].cloneNode(true);
        }

        // Generate unique IDs for each field in the cloned section
        clonedSection
          .querySelectorAll("input:not([type=hidden]), textarea, select")
          .forEach(function (input) {
            input.value = "";
            const parent = input.closest(".fieldWrapper");
            const child = parent.querySelector(".fieldErrorWrapper");
            const label = parent.querySelector("label");
            child.classList.remove("error");
            child.innerHTML = "";
            let originalId = input.getAttribute("id");
            let originalName = input.getAttribute("name");
            if (originalId && originalName) {
              let stepNumber = formCount;
              let newId = originalId.replace(/\d+/, stepNumber);
              let newName = originalName.replace(/\d+/, stepNumber);
              input.setAttribute("id", newId);
              input.setAttribute("name", newName);
              label.setAttribute("for", newId);
            }
          });

        clonedSection
          .querySelectorAll("input[type=hidden]")
          .forEach(function (input) {
            let originalFieldName = input.getAttribute("name");
            if (originalFieldName) {
              // Check if the field should be deleted
              const shouldDelete = originalFieldName.endsWith("DELETE");

              if (shouldDelete) {
                input.remove(); // Remove the input element
              }
            }
          });

        formCount++;
        let stepNumber = formCount;
        stepFormId.value = stepNumber;
        let clonedEditButton = clonedSection.querySelector(".toggle-content");
        clonedEditButton.hidden = true;
        let originalControls = clonedEditButton.getAttribute("aria-controls");
        let originalLabel = clonedEditButton.getAttribute("aria-label");
        if (originalControls) {
          let newControls = originalControls.replace(/\d+/, stepNumber);
          clonedEditButton.setAttribute("aria-controls", newControls);
        }
        if (originalLabel) {
          let newLabel = originalLabel.replace(/\d+/, stepNumber);
          clonedEditButton.setAttribute("aria-label", newLabel);
        }

        let status = clonedSection.querySelector(".status-bar");
        status.hidden = true;
        let textNode = status.firstChild;
        textNode.textContent = "Step added";

        let clonedHeading = clonedSection.querySelector(
          ".simple-card__heading"
        );
        let headingCounter = clonedHeading.querySelector(".step-counter");
        let titleElement = clonedHeading.querySelector(".text-reg");
        headingCounter.textContent = "Step " + stepNumber + ": ";
        titleElement.textContent = "Add new step";

        // Find the parent element within the cloned section to insert the new field
        let formContentWrapper = clonedSection.querySelector(".full-content");
        let originalId = formContentWrapper.getAttribute("id");
        let newId = originalId.replace(/\d+/, stepNumber);
        formContentWrapper.setAttribute("id", newId);

        // Create the new field element
        let titleField = clonedSection.querySelector(
          'input[type="text"][name$="-name"]:not([name^="-"])'
        );
        let newField;
        if (!titleField) {
          newField = document.createElement("div");
          newField.className = "fieldWrapper form-control";
          newField.innerHTML = `
                <div class="fieldInputWrapper">
                    <label class="label" for="id_toolkit_steps-${
                      stepNumber - 1
                    }-name">Step title</label>
                    <p class="field-desc">Create a title for your new step</p>
                    <input type="text" required="true" id="id_toolkit_steps-${
                      stepNumber - 1
                    }-name" name="toolkit_steps-${
            stepNumber - 1
          }-name" class="form-control">
                </div>
                <div class="fieldErrorWrapper "></div>
            `;

          formContentWrapper.insertBefore(
            newField,
            formContentWrapper.firstChild
          );
        }

        // Show the cloned section
        clonedSection.removeAttribute("hidden");
        let clonedFullContent = clonedSection.querySelector(".full-content");
        clonedFullContent.removeAttribute("hidden");
        clonedFullContent.setAttribute("aria-hidden", "false");

        // Change the text of the update button to "Save"
        let clonedUpdateButton = clonedSection.querySelector(".btn-primary");
        clonedUpdateButton.textContent = "Save";

        // Add functionality to delete button
        let deleteButton = clonedSection.querySelector(".js-delete-step");

        deleteButton.addEventListener("click", function () {
          const simpleCardElement = deleteButton.closest(".simple-card");

          // Get the index of the step to be deleted
          const simpleCardSiblings = Array.from(
            simpleCardElement.parentElement.querySelectorAll(".simple-card")
          );
          const deletedIndex = simpleCardSiblings.indexOf(simpleCardElement);
          // Get all the remaining step containers after deletion
          const remainingStepContainers =
            document.querySelectorAll(".simple-card");

          // Loop through the remaining steps and update their attributes
          remainingStepContainers.forEach((remainingStep, remainingIndex) => {
            if (remainingIndex >= deletedIndex) {
              const stepNumber = remainingIndex - 1;
              remainingStep
                .querySelectorAll("input:not([type=hidden]), textarea, select")
                .forEach(function (input) {
                  const parent = input.closest(".fieldWrapper");
                  const label = parent.querySelector("label");
                  let originalId = input.getAttribute("id");
                  let originalName = input.getAttribute("name");
                  if (originalId && originalName) {
                    let newId = originalId.replace(/\d+/, stepNumber);
                    let newName = originalName.replace(/\d+/, stepNumber);
                    input.setAttribute("id", newId);
                    input.setAttribute("name", newName);
                    label.setAttribute("for", newId);
                  }
                });
              let clonedEditButton =
                remainingStep.querySelector(".toggle-content");
              let originalControls =
                clonedEditButton.getAttribute("aria-controls");
              let originalLabel = clonedEditButton.getAttribute("aria-label");
              if (originalControls) {
                let newControls = originalControls.replace(
                  /\d+/,
                  stepNumber + 1
                );
                clonedEditButton.setAttribute("aria-controls", newControls);
              }
              if (originalLabel) {
                let newLabel = originalLabel.replace(/\d+/, stepNumber + 1);
                clonedEditButton.setAttribute("aria-label", newLabel);
              }
              let formContentWrapper =
                remainingStep.querySelector(".full-content");
              let formContentOriginalId = formContentWrapper.getAttribute("id");
              let formContentNewId = formContentOriginalId.replace(
                /\d+/,
                stepNumber + 1
              );
              formContentWrapper.setAttribute("id", formContentNewId);
            }
          });

          simpleCardElement.remove();
          stepFormId.value = formCount - 1;
          formCount--;
        });

        let ctaContainer = clonedSection.querySelector(".cta-container");
        ctaContainer.insertBefore(
          deleteButton,
          ctaContainer.querySelector(".btn-primary")
        );

        clonedUpdateButton.addEventListener("click", function () {
          const stepTitle = clonedSection.querySelector(
            'input[type="text"][name$="-name"]:not([name^="-"])'
          ).value;
          if (stepTitle) {
            titleElement.textContent = stepTitle;
          }
        });

        const errorElement = clonedSection.querySelector(".error-message");
        if (errorElement) {
          errorElement.remove();
        }

        // Insert the cloned section after the last section with class simple-card
        let addButton = document.getElementById("addButton");
        addButton.parentNode.insertBefore(clonedSection, addButton);

        //set focus to the input field of the newly added step
        let stepTitleInput = clonedSection.querySelector("input[type='text']");
        if (stepTitleInput) {
          stepTitleInput.focus();
        }
      });
  }
})();
